import { render, staticRenderFns } from "./MainContainer.vue?vue&type=template&id=d2a63e02&"
import script from "./MainContainer.vue?vue&type=script&lang=js&"
export * from "./MainContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports